import React from 'react';
import styled from 'styled-components';

import { DARK_THEME } from 'shared/constants';

import StepNavigationItem from './StepNavigationItem';
import DefaultNavigationContent from './DefaultNavigationContent';
import { DefaultNavigationItem } from './DefaultNavigationContent/types';
import { StepNavigatorProps } from './types';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 21.25rem;
  padding: 1.333333333rem 0;
  box-shadow: ${({ theme }) => theme.mode !== DARK_THEME ? '1px 0 8px rgba(0, 0, 0, 0.24)' : '1px 0 8px rgba(0, 0, 0, 0.5)'};
  box-sizing: border-box;
  overflow: auto;
`;

const StyledItemContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledNavItemWrapper = styled.div`
  cursor: pointer;
`;

const renderNavigationItems = <T extends DefaultNavigationItem>(
  itemConfig: StepNavigatorProps<T>['itemConfig'],
  currentStepIndex: StepNavigatorProps<T>['currentStepIndex'],
  onNavigationItemClick: StepNavigatorProps<T>['onNavigationItemClick'],
  DefaultNavItem: StepNavigatorProps<T>['navItemComponent'],
) => itemConfig.map(({
  name,
  navItemComponent: NavItem = DefaultNavItem || StepNavigationItem,
  navContentComponent: NavigationItemContent = DefaultNavigationContent,
  values,
}, index) => (
  <StyledNavItemWrapper key={name} onClick={() => onNavigationItemClick(name)}>
    <NavItem
      isSelected={currentStepIndex === index}
      currentStepIndex={currentStepIndex}
      stepIndex={index}
      stepName={name}
      numberOfSteps={itemConfig.length}
    >
      <NavigationItemContent values={values} />
    </NavItem>
  </StyledNavItemWrapper>
));

const StepNavigator = <T extends DefaultNavigationItem>({
  currentStepIndex,
  onNavigationItemClick,
  itemConfig,
  navItemComponent: DefaultNavItem,
}: StepNavigatorProps<T>) => (
  <StyledContainer>
    <StyledItemContainer>
      {renderNavigationItems<T>(
        itemConfig,
        currentStepIndex,
        onNavigationItemClick,
        DefaultNavItem,
      )}
    </StyledItemContainer>
  </StyledContainer>
);

export default StepNavigator;
